const translations = {
  "en": {
    "Continue on web": "Continue on web",
    "Download the app to get started.": "Download the app to get started.",
    "Ed's latest features are built for mobile. Scan the QR code or tap below.": "Ed's latest features are built for mobile. Scan the QR code or tap below."
  },
  "zh-tw": {
    "Continue on web": "繼續在網頁上操作",
    "Download the app to get started.": "下載應用程式以開始使用。",
    "Ed's latest features are built for mobile. Scan the QR code or tap below.": "Ed 的最新功能已針對行動裝置進行優化。掃描 QR Code 或點選下方。"
  }
};

export default translations;
